export default __webpack_public_path__ + "static/media/new-tele-dark.fb6dec74.svg";